import { motion } from 'framer-motion';
import React, { FC } from 'react';

import Button from '../../shared/buttonComponents/Button';
import { useWizard, WizardStep } from '../../../contexts/WizardContext';
import ButtonContact from '../../shared/buttonComponents/ButtonContact';


interface ProposalPopupInterface {
  onClose?: any;
  onSubmit?: (selected: any) => void;
}


interface TP {
  app: 'APP',
  notApp: 'NOT'
}

const ProposalPopup: FC<ProposalPopupInterface> = ({ onClose }): JSX.Element => {

  const {
    changeStep,
    updateStepData,
  } = useWizard();


  return (
    <motion.div
      initial={{
        opacity: 0,
        scale: 0
      }}
      animate={{
        opacity: 1,
        scale: 1
      }}
      exit={{
        opacity: 0,
        scale: 0
      }}
      transition={{
        duration: 0.5
      }}
      className="proposal-popup-container"
    >
      <div className="proposal-popup">
        <div className="proposal-popup-close">
          <img
            onClick={onClose}
            src={`${process.env.PUBLIC_URL}/assets/images/close-icon.png`}
            alt=""
          />
        </div>

        <div className="proposal-popup-title">
          Yes, I like it!
          <p>Let's set up my account now</p>
        </div>

        <div className="proposal-popup-button">
          <Button
            title="Let's start setting up"
            onClick={() => {
              changeStep(WizardStep.APPROVAL_FORM);
              updateStepData({
                approvedProposal: 'approved'
              })
            }
            }
          />
        </div>

        <div className='contact-box'>
          <div className='proposal-popup-text'>
            Or... speak with us directly
          </div>
          <ButtonContact
            title='contact us'
            onClick={() => {
              changeStep(WizardStep.REJECTION_FORM)
              updateStepData({
                approvedProposal: 'not-approved'
              })
            }}
          />
        </div>
      </div>

      <div className="proposal-popup-mobile">
        <div className="proposal-popup-close">
          <img
            onClick={onClose}
            src={`${process.env.PUBLIC_URL}/assets/images/X2x.png`}
            alt=""
          />
        </div>

        <div className="proposal-popup-title">
          Yes I like it
          <p>Let's set up my account now</p>
        </div>


        <div className="proposal-popup-button">
          <Button
            title="Let's start setting up"
            onClick={() => {
              changeStep(WizardStep.APPROVAL_FORM);
              updateStepData({
                approvedProposal: 'approved'
              })
            }
            }
          />
        </div>

        <div className='contact-box'>
          <div className='proposal-popup-text'>Or... speak with us directly</div>
          <ButtonContact
            title='contact us'
            onClick={() => {
              changeStep(WizardStep.REJECTION_FORM)
              updateStepData({
                approvedProposal: 'not-approved'
              })
            }}
          />
        </div>

      </div>
    </motion.div>
  );
};

export default ProposalPopup;
